import React from 'react'
import PageTitle from './PageTitle'

const About = (props) => {

    return (
        <section>
            <div className="about-wrapper common-padding">
                <PageTitle title="About" />
                <div className="mt-4 w-100">
                    <div className="p-3 rounded-lg mb-3 about-card">
                        <p>Hi there !</p>
                        <p>
                            I am Karan Das, a B.Sc.IT graduate, having 2+ Years of experience in Front-end Development.
                            <br />
                            I keep on learning new things to make my skillset up-to-date .
                        </p>
                        <p>
                            I specalize in Javascript based web developement frameworks &
                            libraries such as ReactJS, NodeJS etc.
                            <br />
                            And can also build responsive UI with a great user experience and styling.
                        </p>
                        <p className='mb-0'>
                            My key skills includes:
                            <span className="badge badge-custom mx-2 p-1 px-2">ReactJS</span>
                            <span className="badge badge-custom mr-2 p-1 px-2">HTML/CSS</span>
                            <span className="badge badge-custom mr-2 p-1 px-2">Javascript</span>
                            <span className="badge badge-custom mr-2 p-1 px-2">Bootstrap</span>
                            <span className="badge badge-custom mr-2 p-1 px-2">NodeJS</span>
                            & Many more
                        </p>
                    </div>
                    <div className="">
                        <a className="download-btn border-0" href={require('../assets/Resume.pdf')} download>
                            <i className="fa fa-download mr-2"></i>Download my Resume
                        </a>
                    </div>
                </div>
            </div>
            <div className="navi-wrapper">
                <button className="navi-btn" onClick={() => props.setActive("home")} >
                    <i className='fa fa-arrow-up'></i>
                </button>
                <button className="navi-btn" onClick={() => props.setActive("education")} >
                    <i className='fa fa-arrow-down'></i>
                </button>
            </div>
        </section>
    )
}

export default About